var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { getFontSize, getFontWeight } from '../../abstracts/typography';
import { colors } from '../../abstracts/colors';
var borderRadius = 10;
var verticalPadding = 0.75;
var smallButtonCss = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 2rem;\n  padding: ", "rem 1rem;\n"], ["\n  height: 2rem;\n  padding: ", "rem 1rem;\n"])), verticalPadding - 0.5);
var largeButtonCss = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 4rem;\n  padding: ", "rem 1.75rem;\n  font-size: ", ";\n"], ["\n  height: 4rem;\n  padding: ", "rem 1.75rem;\n  font-size: ", ";\n"])), verticalPadding + 0.25, getFontSize(3));
var getButtonSizeCss = function (size) {
    if (size === 'small')
        return smallButtonCss;
    if (size === 'large')
        return largeButtonCss;
    return undefined;
};
var typeDefaultCss = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  &:not(:disabled) {\n    &:hover {\n      background: ", ";\n      border-color: ", ";\n    }\n    &:active {\n      background: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n  }\n  &:disabled {\n    background: ", ";\n    border-color: ", ";\n  }\n  background: ", ";\n  border-color: ", ";\n  color: ", ";\n"], ["\n  &:not(:disabled) {\n    &:hover {\n      background: ", ";\n      border-color: ", ";\n    }\n    &:active {\n      background: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n  }\n  &:disabled {\n    background: ", ";\n    border-color: ", ";\n  }\n  background: ", ";\n  border-color: ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.primaryHover;
}, function (_a) {
    var theme = _a.theme;
    return theme.primaryHover;
}, function (_a) {
    var theme = _a.theme;
    return theme.primaryPressed;
}, function (_a) {
    var theme = _a.theme;
    return theme.primaryPressed;
}, colors.white, colors.disabledBackground, colors.disabledBackground, function (_a) {
    var theme = _a.theme;
    return theme.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.primary;
}, colors.white);
var typeOutlineCss = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  &:not(:disabled) {\n    &:hover {\n      background: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n    &:active {\n      background: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n  }\n  &:disabled {\n    border-color: ", ";\n  }\n  background: transparent;\n  color: ", ";\n  border: 2px solid;\n  border-color: ", ";\n"], ["\n  &:not(:disabled) {\n    &:hover {\n      background: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n    &:active {\n      background: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n  }\n  &:disabled {\n    border-color: ", ";\n  }\n  background: transparent;\n  color: ", ";\n  border: 2px solid;\n  border-color: ", ";\n"])), colors.neutralBrightest, function (_a) {
    var theme = _a.theme;
    return theme.primaryHover;
}, function (_a) {
    var theme = _a.theme;
    return theme.primaryHover;
}, colors.neutralBrighter, function (_a) {
    var theme = _a.theme;
    return theme.primaryPressed;
}, function (_a) {
    var theme = _a.theme;
    return theme.primaryPressed;
}, colors.disabledText, function (_a) {
    var theme = _a.theme;
    return theme.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.primary;
});
var typeFlatCss = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  &:not(:disabled) {\n    &:hover {\n      background: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n    &:active {\n      background: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n  }\n  color: ", ";\n  background: transparent;\n  border-color: transparent;\n"], ["\n  &:not(:disabled) {\n    &:hover {\n      background: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n    &:active {\n      background: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n  }\n  color: ", ";\n  background: transparent;\n  border-color: transparent;\n"])), colors.neutralBrightest, colors.neutralBrightest, function (_a) {
    var theme = _a.theme;
    return theme.primaryHover;
}, colors.neutralBrighter, colors.neutralBrighter, function (_a) {
    var theme = _a.theme;
    return theme.primaryPressed;
}, function (_a) {
    var theme = _a.theme;
    return theme.primary;
});
var btnVariantToCss = {
    "default": typeDefaultCss,
    outline: typeOutlineCss,
    flat: typeFlatCss
};
var iconOnlySmallCss = css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  padding: 0.5rem;\n  height: auto;\n"], ["\n  padding: 0.5rem;\n  height: auto;\n"])));
var iconOnlyMediumCss = css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  padding: 0.75rem;\n  height: auto;\n"], ["\n  padding: 0.75rem;\n  height: auto;\n"])));
var iconOnlyLargeCss = css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  padding: 1rem;\n  height: auto;\n"], ["\n  padding: 1rem;\n  height: auto;\n"])));
var iconOnlyStyle = {
    small: iconOnlySmallCss,
    medium: iconOnlyMediumCss,
    large: iconOnlyLargeCss
};
var buttonPadding = function (_a) {
    var $iconPresent = _a.$iconPresent, $iconSide = _a.$iconSide, $btnSize = _a.$btnSize;
    if (!$iconPresent)
        return '';
    if ($btnSize !== 'small') {
        return $iconSide === 'left'
            ? 'padding-left: 1.25rem'
            : 'padding-right: 1.25rem';
    }
    else {
        return $iconSide === 'left'
            ? 'padding-left: 0.75rem'
            : 'padding-right: 0.75rem';
    }
};
export var ButtonElement = styled.button(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  -webkit-font-smoothing: antialiased;\n  border-radius: ", "rem;\n  font-family: inherit;\n  font-weight: ", ";\n  font-style: normal;\n  font-size: ", ";\n  height: 3rem;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-style: solid;\n  border-width: 2px;\n\n  letter-spacing: 0;\n  width: auto;\n  text-align: center;\n  white-space: nowrap;\n  padding: ", "rem 1.75rem;\n\n  &:hover:not([disabled]) {\n    cursor: pointer;\n  }\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n\n  ", ";\n\n  &:disabled {\n    color: ", ";\n    cursor: not-allowed;\n  }\n"], ["\n  -webkit-font-smoothing: antialiased;\n  border-radius: ", "rem;\n  font-family: inherit;\n  font-weight: ", ";\n  font-style: normal;\n  font-size: ", ";\n  height: 3rem;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-style: solid;\n  border-width: 2px;\n\n  letter-spacing: 0;\n  width: auto;\n  text-align: center;\n  white-space: nowrap;\n  padding: ", "rem 1.75rem;\n\n  &:hover:not([disabled]) {\n    cursor: pointer;\n  }\n  ", ";\n  ", ";\n\n  ",
    ";\n  ",
    ";\n\n  ",
    ";\n\n  &:disabled {\n    color: ", ";\n    cursor: not-allowed;\n  }\n"])), borderRadius, getFontWeight('base'), getFontSize(2), verticalPadding, function (_a) {
    var $btnSize = _a.$btnSize;
    return getButtonSizeCss($btnSize);
}, function (_a) {
    var $btnVariant = _a.$btnVariant;
    return btnVariantToCss[$btnVariant];
}, function (_a) {
    var $iconPresent = _a.$iconPresent, $iconSide = _a.$iconSide, $btnSize = _a.$btnSize;
    return buttonPadding({ $iconPresent: $iconPresent, $iconSide: $iconSide, $btnSize: $btnSize });
}, function (_a) {
    var $childrenPresent = _a.$childrenPresent, $btnSize = _a.$btnSize;
    return !$childrenPresent && iconOnlyStyle[$btnSize];
}, function (_a) {
    var $iconPresent = _a.$iconPresent, $btnVariant = _a.$btnVariant;
    return !$iconPresent && $btnVariant === 'flat'
        ? 'text-decoration: underline; text-underline-position: under;'
        : '';
}, colors.disabledText);
var btnSizeIconMargins = {
    small: {
        left: '0 0.25rem 0 0',
        right: '0 0 0 0.25rem'
    },
    medium: {
        left: '0 0.5rem 0 0',
        right: '0 0 0 0.5rem'
    },
    large: {
        left: '0 0.5rem 0 0',
        right: '0 0 0 0.5rem'
    }
};
export var IconWrapper = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  margin: ", ";\n"], ["\n  margin: ",
    ";\n"])), function (_a) {
    var $childrenPresent = _a.$childrenPresent, $iconSide = _a.$iconSide, $size = _a.$size;
    return $childrenPresent
        ? $iconSide === 'left'
            ? btnSizeIconMargins[$size].left
            : btnSizeIconMargins[$size].right
        : '0';
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
